import {Component, ComponentRef, Injector, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {DialogBaseComponent} from "../../../base-admin-panel/dialog-base/dialog-base.component";
import {StopViewModel} from "../../Model/RouteViewModel";
import {GeozoneViewModel} from "../../../Geozone/Model/GeozoneViewModel";
import {ObjectsManagementDialogComponent} from "../../../objects-management-dialog/objects-management-dialog.component";
import {DialogService} from "../../../../../services/dialog.service";
import { TranslateService } from "@ngx-translate/core";

declare var moment;

@Component({
    selector: 'app-zone-mgmt-component',
    templateUrl: './zone-mgmt-component.component.html',
    styleUrls: ['./zone-mgmt-component.component.css'],
    standalone: false
})
export class ZoneMgmtComponent extends DialogBaseComponent<StopViewModel> implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;

  public zones: GeozoneViewModel[] = [];

  public time: string;
  private dialogService: DialogService;
  protected translateService: TranslateService;

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogService = injector.get(DialogService);
    this.translateService = injector.get(TranslateService);
  }

  ngOnInit() {
    if (this.model.ZoneId && this.zones.length > 0) {
      let selectedZone = this.zones.find(z => z.Id == this.model.ZoneId);
      if (!selectedZone) return;
      this.model.Zone = selectedZone;
    }
    this.time = moment.utc(moment.duration({s: this.model.Time}).asMilliseconds()).format("HH:mm:ss");
  }


  submit() {
    if (!this.model.ZoneId || this.model.ZoneId == 0) {
      this.toastr.error(this.translateService.instant('Geozone is required'));
      return;
    }
    super.submit();
    this.model.Time = moment(this.time,'HH:mm:ss').diff(moment().startOf('day'), 'seconds')
  }

  public selectGeoZone() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.zones;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(zone => {
        if (zone && zone.IsChecked) {
          this.model.ZoneId = zone.Id;
          this.model.Zone = zone;
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }
}
